'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function History(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M544 494.4l152.48 88.032a31.872 31.872 0 0 1 11.616 43.68c-8.832 15.296-28.544 20.48-43.616 11.776l-166.464-96.096a31.968 31.968 0 0 1-8.288-6.88 31.776 31.776 0 0 1-9.728-22.752v-256.32c0-17.6 14.208-31.84 32-31.84 17.664 0 32 14.592 32 31.84v238.592zM512 96c229.504 0 416 186.496 416 416s-186.496 416-416 416S96 741.504 96 512 282.496 96 512 96z m0 768c194.304 0 352-157.696 352-352S706.304 160 512 160 160 317.696 160 512s157.696 352 352 352z' })
  );
}
History.displayName = 'History';

module.exports = History;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/history.js
// module id = 179
// module chunks = 0